import Cookie from 'js-cookie';

const cookieName = (featureId) => `gb_${featureId}`;

export const saveFeatureValueToStorage = ({ featureId, variationValue, expires = 30 }) => {
  if (!featureId) {
    return;
  }

  Cookie.set(cookieName(featureId), variationValue, { expires });
};

export const getFeatureValueFromStorage = (featureId) => {
  return Number(Cookie.get(cookieName(featureId))) || undefined;
};
